import { Select,Form, Space, Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { useGetUserDeptManageQuery } from '../store/ReactWebSiteApi';
import DeptList from '../sys/deptUser/DeptList';

function GetUserDept(props) {
    const [list,setList] = useState('');
    const {data, isSuccess} = useGetUserDeptManageQuery({eu_id:localStorage.getItem('eu_id'),ed_state:'2'});
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {ed_id,ed_name,}=item;
                    return item = {value:ed_id,label:ed_name}
                })
                if(props.selectAll){
                    newArr.unshift({value:'',label:'所有部门'})
                    setList(newArr)
                }else{
                    setList(newArr)  
                }              
            }
        }
    },[data, isSuccess, props.selectAll])
    const [open, setOpen] = useState(false);
    return (
        <Form.Item 
            label={props.label} 
            wrapperCol={props.wrapperCol} 
            labelCol={props.labelCol}
            required={props.required}  
            style={props.FormStyle}    
            tooltip="如果没有显示你需要的部门，请修改你的部门权限"
        >
            <Space>
                <Form.Item 
                    name={props.name}      
                    initialValue={props.initialValue}    
                >
                    <Select 
                        options={list} 
                        onChange={(_,f) => {
                            // console.log(f);
                            props.getUserDept(f.value,f.label)
                        }}
                        style={props.style}
                        disabled={props.initialValue}
                        value={props.value}
                    />
                </Form.Item>
                {!props.setDept && <Form.Item style={{width:"30px"}}>
                    <a onClick={() => {setOpen(true)}}>设置</a>
                </Form.Item>}
            </Space>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {}}
                footer={null}
                width={800}
                title='部门设置'
            >
                <DeptList/>
            </Modal>
        </Form.Item>
    )
}

export default GetUserDept